import {Component, Input} from "@angular/core";
import {JP} from "../../helpers/jp";
import {FactoryService} from "../../services/factory.service";
import {localeUtils} from "../../helpers/locale-utils";
import {IQuestStage} from "../../interfaces/quest.definition";
import {VALUE_TYPE} from "../../enums/enums";
import {UI_TEXTS} from "../../enums/e-texts";


@Component({
  selector: "nv-stages",
  templateUrl: "./nv-stages.component.html"
})


export class NvStagesComponent {
  UI_TEXTS = UI_TEXTS;
  VAL_TYPES = VALUE_TYPE;

  private _document: any;
  private _pointer: string;
  private _selected: IQuestStage;

  @Input() set document(v: any) {
    this._document = v;
  }

  @Input() set pointer(v: string) {
    this._pointer = v;
  }

  get document() { return this._document; }
  get pointer() { return this._pointer; }
  get selected() { return this._selected; }
  get stages() { return JP.get(this.document, this.pointer); }


  constructor(private factoryService: FactoryService) {
  }


  getItemLabel(stage: IQuestStage) {
    return localeUtils.findName(stage);
  }


  onItemSelected(stage: IQuestStage) {
    this._selected = stage;
  }


  onAddClick() {
    this.factoryService.addQuestStageTo(this.document, this.pointer);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-stages/nv-stages.component.ts